export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="w-full bg-secondary-900 text-secondary-200">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-background-50 text-base"></i>
              </div>
              <span className="text-lg font-heading text-secondary-100">花生影院</span>
            </div>
            <p className="text-sm text-secondary-400 leading-relaxed">
              你的私人电影大全。海量高清电影资源免费在线观看，每日更新最新片源，打造极致观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-secondary-100 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {[
                { label: '精选专题', href: '#index' },
                { label: '热门榜单', href: '#ranking' },
                { label: '最新快讯', href: '#updates' },
                { label: '焦点推荐', href: '#carousel' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo(item.href);
                    }}
                    className="text-sm text-secondary-400 hover:text-secondary-100 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-secondary-100 mb-4">更多内容</h4>
            <ul className="space-y-2.5">
              {[
                { label: '观影评价', href: '#comments' },
                { label: '精彩预告', href: '#media' },
                { label: '热门话题', href: '#topics' },
                { label: '常见问题', href: '#faq' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo(item.href);
                    }}
                    className="text-sm text-secondary-400 hover:text-secondary-100 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-secondary-100 mb-4">联系与合作</h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="#contact"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollTo('#contact');
                  }}
                  className="text-sm text-secondary-400 hover:text-secondary-100 transition-colors cursor-pointer"
                >
                  联系我们
                </a>
              </li>
              <li>
                <a
                  href="#about"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollTo('#about');
                  }}
                  className="text-sm text-secondary-400 hover:text-secondary-100 transition-colors cursor-pointer"
                >
                  关于花生影院
                </a>
              </li>
              <li>
                <a
                  href="#features"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollTo('#features');
                  }}
                  className="text-sm text-secondary-400 hover:text-secondary-100 transition-colors cursor-pointer"
                >
                  平台优势
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-secondary-700/50 pt-8 mb-8">
          <h4 className="text-sm font-medium text-secondary-300 mb-4 text-center">
            合作伙伴
          </h4>
          <div className="flex flex-wrap items-center justify-center gap-6 text-secondary-500">
            <div className="text-sm px-4 py-2 rounded-lg bg-secondary-800/50 whitespace-nowrap">合作品牌入驻中</div>
            <div className="text-sm px-4 py-2 rounded-lg bg-secondary-800/50 whitespace-nowrap">欢迎洽谈合作</div>
            <div className="text-sm px-4 py-2 rounded-lg bg-secondary-800/50 whitespace-nowrap">品牌联合推广</div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-6 border-t border-secondary-700/50">
          <p className="text-xs text-secondary-500">
            &copy; 2026 花生影院 huashengcinema.com 版权所有
          </p>
          <p className="text-xs text-secondary-500">
            电影大全 · 最新电影 · 免费在线观看 · 高清不缓冲
          </p>
        </div>
      </div>
    </footer>
  );
}